import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EditIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edit"}/>
}
